export default __webpack_public_path__ + "static/chunks/ui-assets/pattern-grid-white/b0d09336b90505c799e723dc11bdbb7f.png";